import { Pill, Tooltip } from '@mantine/core';
import { FC } from 'react';

import { color_mapping } from '@/constants/priority.ts';
import { urgency_priority_map } from '@/constants/urgency.ts';

import { EnrichedTask, task_urgency_de_translation } from '@/models/doc-cirrus/DCTask.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    task: EnrichedTask;
}

const TaskPills: FC<Props> = ({ task }) => {
    const urgency = task.urgency && urgency_priority_map[task.urgency];
    return (
        <div className="flex gap-2">
            {task.type_name && (
                <Tooltip label="Typ">
                    <Pill>{task.type_name}</Pill>
                </Tooltip>
            )}
            {task.urgency && (
                <Tooltip label="Dringlichkeit">
                    <Pill className={cn('text-white', urgency && `bg-${color_mapping[urgency]}`)}>
                        {task_urgency_de_translation[task.urgency]}
                    </Pill>
                </Tooltip>
            )}
            <Tooltip label="Status">
                <Pill>{task.status}</Pill>
            </Tooltip>
        </div>
    );
};

export default TaskPills;
